import React, { useState } from "react";
import { assetUrl } from "@/lib/api";

export function SupplierImg({ product, alt, className, ...rest }) {
  const [failed, setFailed] = useState(false);
  const src = product?.image ? assetUrl(product.image) : null;
  if (!src || failed) return <div className={`${className} grid place-items-center bg-secondary text-[10px] font-bold uppercase tracking-wider text-muted-foreground`} data-testid="image-pending">Image pending</div>;
  return <img src={src} alt={alt || product?.name || ""} className={className} loading="lazy" onError={() => setFailed(true)} {...rest} />;
}
